import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const UzbekistanMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Uzbekistan</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — considered equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              5 years (Some universities may offer 6-year programs including
              internship)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB (40% for SC/ST/OBC)</li>
              <li>NEET qualification is mandatory (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">
              English (with basic Russian/Uzbek taught for local interaction)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, WFME, ECFMG</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <p className="detail-text">
              Affordable tuition and living costs, English-medium programs,
              Culturally friendly for Indian students.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in Uzbekistan
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Tashkent Medical Academy (TMA), Tashkent
              </h3>
              <p className="university-description">
                Premier government medical university. NMC and WHO recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Samarkand State Medical University (SamSMU), Samarkand
              </h3>
              <p className="university-description">
                One of the oldest and most reputed universities in Uzbekistan.
                Offers MBBS in English.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Bukhara State Medical Institute, Bukhara
              </h3>
              <p className="university-description">
                Affordable and well-recognized. English-taught MD program with
                growing international student base.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Andijan State Medical Institute, Andijan
              </h3>
              <p className="university-description">
                Government university. Good academic infrastructure and
                recognized by NMC.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Fergana State University – Faculty of Medicine, Fergana
              </h3>
              <p className="university-description">
                Rising in popularity. Offers MBBS in English with modern
                facilities.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Tashkent Pediatric Medical Institute, Tashkent
              </h3>
              <p className="university-description">
                Specializes in pediatric and general medicine. WHO and NMC
                recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Urgench Branch of Tashkent Medical Academy, Urgench
              </h3>
              <p className="university-description">
                Extension of TMA. NMC-approved and English-medium.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default UzbekistanMbbs;
